import { styled } from 'styled-components';
import { fadeInKeyframes } from '@inter-ikea-guida/framework';
import { SkapaColors, SkapaTokens } from '@inter-ikea-guida/skapa';
// empty solution styles
export const StyledFooter = styled.div `
  display: flex;
  justify-content: ${props => (props.$isEmpty ? 'flex-end' : 'space-between')};
  align-items: center;

  margin-top: ${SkapaTokens.space50};
`;
export const StyledFlexColumn = styled.div `
  display: flex;
  flex-direction: column;
`;
export const StyledAnimatedFlexColumn = styled.div `
  display: flex;
  flex-direction: column;
  animation: ${fadeInKeyframes} 1s ease-in;
`;
export const StyledProductImageButton = styled.button `
  position: relative;
  display: block;
  border: none;
  padding: 0;
  background-color: transparent;
  cursor: pointer;
  text-align: start;
`;
export const StyledInformationIconWrapper = styled.div `
  position: absolute;
  top: 0;
  right: ${({ rtl }) => (rtl ? 'auto' : 0)};
  left: ${({ rtl }) => (rtl ? 0 : 'auto')};
`;
export const StyledHoverImageWrapper = styled.div `
  position: absolute;
  top: 0;
  opacity: ${props => (props.$show ? 1 : 0)};
  background-color: ${SkapaColors.colourStaticWhite};
  transition: opacity 0.1s ease-in;
`;
export const StyledCheckmarkContainer = styled.div `
  border-radius: ${SkapaTokens.radiusCap};
  background-color: ${SkapaColors.colourStaticBlack};
  color: ${SkapaColors.colourStaticWhite};
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 8px;
  top: 8px;

  animation: ${fadeInKeyframes} ${SkapaTokens.durationStandardWeb} ease-in;
`;
// Product Availability and Home Delivery styles
export const StyledAvailabilityWrapper = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${SkapaTokens.space25};
`;
export const StyledAvailability = styled.div `
  display: flex;
  margin-top: ${props => (props.$margin ? props.$margin : 0)}px;

  span {
    display: flex;
    flex-direction: row-reverse;
    align-items: baseline;

    span {
      font-size: 12px;
      .status__dot {
        margin-right: 10px;
        margin-inline-start: 0;
      }
    }
  }
`;
// Product List Products styles
export const StyledProductContainer = styled.div `
  display: grid;
  grid-template-columns: ${props => (props.$isMobile ? '1fr' : '1fr 1fr 1fr')};
  gap: 3rem;
  padding-bottom: 2rem;
  grid-auto-rows: 1fr;
  height: ${props => (props.$isSkeleton ? '45vw' : 'unset')};
`;
// Show more styles
export const StyledShowMore = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 4rem;
  width: 100%;
`;
export const StyledPriceWrapper = styled.div `
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-top: ${SkapaTokens.space50};
  cursor: pointer;

  * {
    cursor: pointer !important;
  }
`;
export const StyledContainer = styled.div `
  animation: ${fadeInKeyframes} 1s ease-in;
  display: flex;
  flex-direction: column;
  gap: ${SkapaTokens.space100};
`;
//# sourceMappingURL=styles.js.map